module.exports = __webpack_public_path__ + "static/media/addie.79c0cda6.jpg";